import {Component, inject, ViewEncapsulation} from '@angular/core';
import {MatSnackBarAction, MatSnackBarLabel, MatSnackBarRef} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@Component({
	selector: 'error-manager-snackbar',
	standalone: true,
	imports: [MatSnackBarAction, MatSnackBarLabel, MatButtonModule, MatIconModule],
	templateUrl: './error-manager-snackbar.component.html',
	styleUrl: './error-manager-snackbar.component.scss',
	encapsulation: ViewEncapsulation.None
})
export class ErrorManagerSnackbarComponent {
	snackBarRef = inject(MatSnackBarRef);
	message: string = this.snackBarRef.containerInstance.snackBarConfig.data.message;
}
